<template>
  <div id="app" class="container-fluid">

    <heading />

    <home class="section" />
    <work class="section" />
    <bio class="section" />

  </div>
</template>

<script>
import Heading from './components/Heading.vue'

const Home = () => import('./components/Home.vue')
const Work = () => import('./components/Work.vue')
const Bio = () => import('./components/Bio.vue')

export default {
  name: 'app',
  components: {
    Heading,
    Home,
    Work,
    Bio
  },
  updated () {
    setTimeout(function () {
      document.querySelector('html').classList.remove('loading')
      document.querySelector('body').classList.remove('loading')
    }, 1000)
  }
}
</script>

<style>
/*html, body {
  overflow: visible;
}
html { overflow-y: scroll; }*/
</style>



// WEBPACK FOOTER //
// App.vue?b0076786